import axios from 'axios';

export const APPLE_PAY_MERCHANT_URL = process.env.REACT_APP_APPLE_PAY_MERCHANT_VERIFICATION_URL;

const post = (path, data, errorMessage) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: path,
            data: data,
            headers: {'Content-Type': 'application/json'}
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(new Error(errorMessage));
                }
            })
            .catch((error) => {
                console.log(error);
                reject(error);
            });
    });
}

export const performValidation = (url) => {
    const data = {
        url: url
    }
    return post(APPLE_PAY_MERCHANT_URL, data, 'Could not get session')
}

